import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable, of} from 'rxjs';
import {Action} from '@ngrx/store';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as AuthActions from './auth.action';
import {AuthenticationService} from '../../shared/service/auth/authentication.service';

@Injectable()
export class AuthEffects {
  constructor(
    private action$: Actions,
    private authenticationService: AuthenticationService,
  ) {}

  @Effect()
  signIn$: Observable<Action> = this.action$.pipe(
    ofType(AuthActions.SIGN_IN),
    mergeMap((action: AuthActions.SignIn) =>
      this.authenticationService.login(action.payload).pipe(
        map((data: any) => {
          if (data.error_message) {
            return { type: AuthActions.SIGN_IN_ERROR };
          }
          return { type: AuthActions.SIGN_IN_SUCCESS, payload: data };
        }),
        catchError(err => {
          return of({ type: AuthActions.SIGN_IN_ERROR });
        }),
      ),
    ),
  );
}
